"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatFileSize = void 0;
var BYTE_UNITS = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
var BIBYTE_UNITS = ['B', 'kiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
var BIT_UNITS = ['b', 'kbit', 'Mbit', 'Gbit', 'Tbit', 'Pbit', 'Ebit', 'Zbit', 'Ybit'];
var BIBIT_UNITS = ['b', 'kibit', 'Mibit', 'Gibit', 'Tibit', 'Pibit', 'Eibit', 'Zibit', 'Yibit'];
var DEFAULT_MAXIMUM_FRACTION = 1;

var getUnits = function getUnits(options) {
  if (options.bits) {
    return options.binary ? BIBIT_UNITS : BIT_UNITS;
  }

  return options.binary ? BIBYTE_UNITS : BYTE_UNITS;
};

var getPrefix = function getPrefix(isNegative, options) {
  if (isNegative) {
    return '-';
  }

  return options.signed ? '+' : '';
};

var formatFileSize = function formatFileSize(number) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    bits: false,
    binary: false
  };

  if (!Number.isFinite(number)) {
    // eslint-disable-next-line no-console
    console.error("Expected a finite number, got ".concat(typeof number, ": ").concat(number));
    return '';
  }

  var UNITS = getUnits(options);

  if (options.signed && number === 0) {
    return " 0 ".concat(UNITS[0]);
  }

  var isNegative = number < 0;
  var prefix = getPrefix(isNegative, options);
  var resultNumber = number;

  if (isNegative) {
    resultNumber = -number;
  }

  var localeOptions = {
    minimumFractionDigits: options.minimumFractionDigits,
    maximumFractionDigits: options.maximumFractionDigits || DEFAULT_MAXIMUM_FRACTION
  };

  if (resultNumber < 1) {
    var _numberString = resultNumber.toLocaleString(undefined, localeOptions);

    return "".concat(prefix + _numberString, " ").concat(UNITS[0]);
  }

  var log = options.binary ? Math.log(resultNumber) / Math.log(1024) : Math.log10(resultNumber) / 3;
  var exponent = Math.min(Math.floor(log), UNITS.length - 1);
  resultNumber /= Math.pow(options.binary ? 1024 : 1000, exponent);
  var numberString = resultNumber.toLocaleString(undefined, localeOptions);
  var unit = UNITS[exponent];
  return "".concat(prefix + numberString, " ").concat(unit);
};

exports.formatFileSize = formatFileSize;